import * as React from "react";
const SvgBank = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "#36383B", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 1.5 14.5 5v1.2h-13V5L8 1.5ZM3 7.4h1.8v4.7H3V7.4Zm4.1 0h1.8v4.7H7.1V7.4Zm4.1 0H13v4.7h-1.8V7.4ZM1.5 13.2h13v1.3h-13v-1.3Z" }));
export default SvgBank;
